import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { SideBar } from "../../components";
import {
  bacaMasalah,
  dryRunIndikator,
  getBaselineList,
  getEquivalenceList,
  getFactorList,
  getFormulaVariables,
  getIndikatorList,
  validasiIndikator,
} from "../../config/redux/action/sustainabilityAction";
import TabRegistry from "./TabRegistry";
import TabFactor from "./TabFactor";
import TabBaseline from "./TabBaseline";
import TabEquivalence from "./TabEquivalence";
import TabPublishingRules from "./TabPublishingRules";
import ModalIndikator from "./ModalIndikator";
import ModalDryRun from "./ModalDryRun";
import ModalValidasi from "./ModalValidasi";
import ModalPublish from "./ModalPublish";

const DAFTAR_TAB = [
  { id: 1, nama: "Indicator Registry" },
  { id: 2, nama: "Factor Table" },
  { id: 3, nama: "Baseline Management" },
  { id: 4, nama: "Equivalence" },
  { id: 5, nama: "Publishing Rules" },
];

function IndicatorSettingsPage() {
  const {
    IndikatorList,
    BaselineList,
    FactorList,
    EquivalenceList,
    FormulaVariables,
  } = useSelector((state) => state.sustainabilityReducer);

  const [Tabs, setTabs] = useState(1);
  const [Update, setUpdate] = useState(1);
  const [FilterStatus, setFilterStatus] = useState("");
  const [FilterKategori, setFilterKategori] = useState("");

  const [Terpilih, setTerpilih] = useState(null);
  const [ShowForm, setShowForm] = useState(false);

  const [ShowValidasi, setShowValidasi] = useState(false);
  const [HasilValidasi, setHasilValidasi] = useState(null);
  const [LoadingValidasi, setLoadingValidasi] = useState(false);

  const [ShowDryRun, setShowDryRun] = useState(false);
  const [HasilDryRun, setHasilDryRun] = useState(null);
  const [LoadingDryRun, setLoadingDryRun] = useState(false);
  const [ErrorDryRun, setErrorDryRun] = useState([]);

  const [ShowTataKelola, setShowTataKelola] = useState(false);
  const [ModeTataKelola, setModeTataKelola] = useState("publish");

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getIndikatorList(FilterStatus, FilterKategori)).catch((err) =>
      console.log(err)
    );
  }, [Update, FilterStatus, FilterKategori]);

  useEffect(() => {
    dispatch(getBaselineList()).catch((err) => console.log(err));
    dispatch(getFactorList()).catch((err) => console.log(err));
    dispatch(getEquivalenceList()).catch((err) => console.log(err));
    dispatch(getFormulaVariables()).catch((err) => console.log(err));
  }, [Update]);

  const segarkan = () => setUpdate(Update + 1);

  const bukaForm = (baris) => {
    setTerpilih(baris);
    setShowForm(true);
  };

  const jalankanValidasi = (baris) => {
    setTerpilih(baris);
    setHasilValidasi(null);
    setLoadingValidasi(true);
    setShowValidasi(true);
    dispatch(validasiIndikator(baris.id))
      .then((res) => setHasilValidasi(res.data))
      .catch((err) =>
        setHasilValidasi({ valid: false, masalah: bacaMasalah(err) })
      )
      .finally(() => setLoadingValidasi(false));
  };

  const jalankanDryRun = (baris, hari) => {
    setTerpilih(baris);
    setErrorDryRun([]);
    setLoadingDryRun(true);
    setShowDryRun(true);
    dispatch(dryRunIndikator(baris.id, hari || 30))
      .then((res) => setHasilDryRun(res.data))
      .catch((err) => {
        setHasilDryRun(null);
        setErrorDryRun(bacaMasalah(err));
      })
      .finally(() => setLoadingDryRun(false));
  };

  const bukaTataKelola = (baris, mode) => {
    setTerpilih(baris);
    setModeTataKelola(mode);
    setShowTataKelola(true);
  };

  return (
    <div>
      <SideBar />
      <div className="content px-1">
        <div className="card p-3 mb-3 shadow d-flex flex-row">
          <div
            className="nav d-flex flex-column flex-shrink-0"
            style={{ fontSize: "12px", fontWeight: "bold" }}
          >
            {DAFTAR_TAB.map((val) => (
              <button
                key={val.id}
                className="nav-link border-0 text-decoration-none fw-bold text-dark mb-2 d-flex justify-content-center align-items-center"
                onClick={() => setTabs(val.id)}
                style={Tabs === val.id ? { backgroundColor: "#33D49D" } : null}
              >
                <div className={`px-2 ${Tabs === val.id ? "text-white" : ""}`}>
                  {val.nama}
                </div>
              </button>
            ))}
          </div>

          <div className="ms-2 w-100" style={{ minWidth: 0 }}>
            {Tabs === 1 ? (
              <TabRegistry
                list={IndikatorList}
                status={FilterStatus}
                kategori={FilterKategori}
                onChangeStatus={setFilterStatus}
                onChangeKategori={setFilterKategori}
                onTambah={() => bukaForm(null)}
                onEdit={bukaForm}
                onValidasi={jalankanValidasi}
                onDryRun={(baris) => jalankanDryRun(baris, 30)}
                onPublish={(baris) => bukaTataKelola(baris, "publish")}
                onArchive={(baris) => bukaTataKelola(baris, "archive")}
              />
            ) : Tabs === 2 ? (
              <TabFactor list={FactorList} update={segarkan} />
            ) : Tabs === 3 ? (
              <TabBaseline
                list={BaselineList}
                indikatorList={IndikatorList}
                update={segarkan}
              />
            ) : Tabs === 4 ? (
              <TabEquivalence
                list={EquivalenceList}
                indikatorList={IndikatorList}
                update={segarkan}
              />
            ) : (
              <TabPublishingRules
                indikatorList={IndikatorList}
                baselineList={BaselineList}
              />
            )}
          </div>
        </div>
      </div>

      <ModalIndikator
        show={ShowForm}
        handleClose={() => setShowForm(false)}
        data={Terpilih}
        baselineList={BaselineList}
        formulaVariables={FormulaVariables}
        update={segarkan}
      />

      <ModalValidasi
        show={ShowValidasi}
        handleClose={() => setShowValidasi(false)}
        indikator={Terpilih}
        hasil={HasilValidasi}
        loading={LoadingValidasi}
      />

      <ModalDryRun
        show={ShowDryRun}
        handleClose={() => setShowDryRun(false)}
        indikator={Terpilih}
        hasil={HasilDryRun}
        loading={LoadingDryRun}
        error={ErrorDryRun}
        onUlang={(hari) => jalankanDryRun(Terpilih, hari)}
      />

      <ModalPublish
        show={ShowTataKelola}
        handleClose={() => setShowTataKelola(false)}
        indikator={Terpilih}
        mode={ModeTataKelola}
        update={segarkan}
      />
    </div>
  );
}

export default IndicatorSettingsPage;
